import { render, staticRenderFns } from "./BlogNav.vue?vue&type=template&id=4ebbb018&scoped=true"
import script from "./BlogNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogNav.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BlogNav.vue?vue&type=style&index=0&id=4ebbb018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebbb018",
  null
  
)

export default component.exports